import { useEffect, useState } from 'react';
import Lead from "./lead"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import { useToast } from './useToast';

const Assets = (props) => {
    const [data, setData] = useState({})
    const [type, setType] = useState(null)
    const [customSwiper, setCustomSwiper] = useState(null)
    let userAgent = navigator.userAgent;
    let isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1; //android终端或者uc浏览器
    var isWeixin = userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
    const showToast = useToast();

    const getSwiperIns = (swiperIns) => {
        setCustomSwiper(swiperIns)
    }
    const handlePrev = () => {
        console.log('prev')
        customSwiper.slidePrev()
    }
    const handleNext = () => {
        customSwiper.slideNext()
    }
    const isSafari = () => {
        // 判断用户代理是否包含 "Safari" 但不包含 "Chrome"
        const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

        return isSafari;
    }

    const [isClick, setClick] = useState(null)

    useEffect(() => {
        setType(props.data.type);
        //获取详情
        const myHeaders = new Headers();
        if (props.data.id) {
            let apiurl = '';
            if (props.data.type == 1) {
                apiurl = 'assets/wechat/receive/info';
            } else if (props.data.type == 2) {
                apiurl = 'assets/wechat/share/info';
            }
            fetch(`${process.env.REACT_APP_WEB3_BASE_URL}/${apiurl}/${props.data.id}`, {
                method: 'GET',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default'
            }).then(response => response.json())
                .then(res => {
                    console.log(res)
                    if (res.code === 1) {
                        setData(res.data);
                    }
                })
        }
    }, [props.data])
    useEffect(() => {
        if (isiOS && !isSafari() && !isWeixin) {
            showToast('为了保证您可以正常体验功能，请在 Safair 浏览器中打开此页面地址');
        }
        if (window.JMLink) {
            new window.JMLink({
                autoLaunchApp: false,
                jmlink: process.env.REACT_APP_JMLINK,// 短链地址
                button: document.querySelector('.download'),
                params: { ttpath: window.location.href },
                directDownload: true
            });
            new window.JMLink({
                autoLaunchApp: false,
                jmlink: process.env.REACT_APP_JMLINK,// 短链地址
                button: document.querySelector('.open'),
                params: { ttpath: window.location.href },
                directDownload: true
            });
        }
    }, [])
    return (
        <div className='webassets-wrapper'>
            {isAndroid && isWeixin && isClick && <Lead />}
            <div id='content'>
                <div className={["name", type == 1 ? "receive" : ""].join(' ')}>{data.titleValue}</div>
                {data.opbAddress && <div className='address'>博物馆地址：{data.opbAddress}</div>}
                {type == 1 && data.assetList && <>
                    <Swiper
                        modules={[Autoplay]}
                        onSwiper={getSwiperIns}
                        autoplay={{ delay: 3000 }}
                        loop={true}
                        navigation={{
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                            disabledClass: 'disable' // 当导航按钮变为不可用时添加的class,也就是当swiper索引为0时上一张没有prevEl的class类名就会添加一个disable，也就是.swiper-button-prev .disable
                        }}
                    >
                        {
                            data.assetList.map((item, index) => {
                                return (
                                    <SwiperSlide key={index}>
                                        <div className='assets-wrapper'>
                                            <div className='assets-name'>{item.assetName}</div>
                                            <div className='assets-img'>
                                                <div className='top'>
                                                    <img src={item.imageUrl} alt="" />
                                                </div>
                                                <img src={require('../assets/img/bottom.png')} className='bottom' alt="" />
                                                <div className='type'>
                                                    {item.typeName}资产
                                                    <img src={require('../assets/img/border.png')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                )
                            })
                        }
                        <img className="swiper-button-prev" onClick={handlePrev} src={require('../assets/img/prev.png')} alt="" />
                        <img className="swiper-button-next" onClick={handleNext} src={require('../assets/img/next.png')} alt="" />
                    </Swiper>
                </>}
                {type == 2 && <>
                    <div className='assets-img'>
                        <div className='top'>
                            <img src={data.imageUrl} alt="" />
                        </div>
                        <img src={require('../assets/img/bottom.png')} className='bottom' alt="" />
                    </div>
                </>}
                <div className='button-group'>
                    {isAndroid && isWeixin ? (
                        <div onClick={() => setClick(true)}>
                            <img src={require('../assets/img/download1.png')} alt="" />
                        </div>) : (
                        <div className='download'>
                            <img src={require('../assets/img/download1.png')} alt="" />
                        </div>)}
                    {
                        isAndroid && isWeixin ? (
                            <div onClick={() => setClick(true)}>
                                <img src={require('../assets/img/open1.png')} alt="" />
                            </div>) :
                            (<div className='open'>
                                <img src={require('../assets/img/open1.png')} alt="" />
                            </div>)
                    }

                </div>
            </div>
        </div>
    )

}

export default Assets;